/* Copyright (C) 2025 Captor Fund Management AB - All Rights Reserved
 * Unauthorized copying or viewing of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Contact andreas.lindh@captor.se for information
 */

import gql from "graphql-tag";

export const OP_CONSENTS_QUERY = gql`
    query opConsents($filter: OPConsentFilter) {
        opConsents(filter: $filter) {
            _id
            bic
            createUserId
            createUserInfo {
                name
            }
            psuId
            updateUserId
            updateUserInfo {
                name
            }
            consentId
            access {
                accounts {
                    iban
                }
                balances {
                    iban
                }
                transactions {
                    iban
                }
            }
            recurringIndicator
            validUntil
            frequencyPerDay
            lastActionDate
            consentStatus
            createTimestamp
            updateTimestamp
            clientId
            client {
                name
            }
        }
    }
`;
